import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const DAYS = ["lunes", "martes", "miercoles", "jueves", "viernes", "sabado", "domingo"];
const PERIODS = [
  { key: "lunch", label: "Almuerzo" },
  { key: "dinner", label: "Cena" },
];
const CHANNELS = [
  { key: "reservation", label: "Reservas" },
  { key: "pickup", label: "Retirada" },
  { key: "delivery", label: "Delivery" },
];

function getRule(scheduling, day, period) {
  return scheduling?.service_period_rules?.[day]?.[period] || {
    reservation: "normal",
    pickup: "normal",
    delivery: "normal",
    min_advance_days: 1,
  };
}

export function ServicePeriodRulesCard({ scheduling, setScheduling }) {
  const updateRule = (day, period, field, value) => {
    setScheduling(prev => ({
      ...prev,
      service_period_rules: {
        ...(prev.service_period_rules || {}),
        [day]: {
          ...(prev.service_period_rules?.[day] || {}),
          [period]: {
            ...getRule(prev, day, period),
            [field]: field === "min_advance_days" ? Math.max(1, Number(value || 1)) : value,
          },
        },
      },
    }));
  };

  return (
    <div className="border-t border-border/50 px-6 pb-6 pt-5 space-y-4">
      <div>
        <h3 className="font-bold uppercase">Reglas por turno</h3>
        <p className="text-xs text-muted-foreground mt-1">
          Configure cada canal por almuerzo y cena. “Con antelación” exige reservar o programar el número de días indicado.
          La configuración es exclusiva de este restaurante.
        </p>
      </div>
      <div className="space-y-3">
        {DAYS.map(day => (
          <div key={day} className="rounded-lg border border-border/50 p-3 space-y-3" data-testid={`period-rules-${day}`}>
            <p className="font-semibold capitalize text-sm">{day}</p>
            {PERIODS.map(period => {
              const rule = getRule(scheduling, day, period.key);
              const advanceEnabled = CHANNELS.some(channel => rule[channel.key] === "advance_only");
              return (
                <div key={period.key} className="grid grid-cols-1 md:grid-cols-12 gap-2 items-end bg-secondary/25 rounded-lg p-3">
                  <div className="md:col-span-2"><Label>{period.label}</Label></div>
                  {CHANNELS.map(channel => (
                    <div key={channel.key} className="md:col-span-3 space-y-1">
                      <Label className="text-xs">{channel.label}</Label>
                      <Select value={rule[channel.key] || "normal"} onValueChange={v => updateRule(day, period.key, channel.key, v)}>
                        <SelectTrigger data-testid={`period-${day}-${period.key}-${channel.key}`}><SelectValue /></SelectTrigger>
                        <SelectContent>
                          <SelectItem value="normal">Normal</SelectItem>
                          <SelectItem value="advance_only">Con antelación</SelectItem>
                          <SelectItem value="closed">Cerrado</SelectItem>
                        </SelectContent>
                      </Select>
                    </div>
                  ))}
                  <div className="md:col-span-1 space-y-1">
                    <Label className="text-xs">Días</Label>
                    <Input
                      type="number"
                      min={1}
                      max={30}
                      disabled={!advanceEnabled}
                      value={rule.min_advance_days || 1}
                      onChange={e => updateRule(day, period.key, "min_advance_days", e.target.value)}
                      data-testid={`period-${day}-${period.key}-days`}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
}
